'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
function $ct_Lmealorama_MealCourse__T__T__($thiz, name, description) {
  $thiz.k0 = name;
  $thiz.g6 = description;
  return $thiz;
}
export { $ct_Lmealorama_MealCourse__T__T__ as $ct_Lmealorama_MealCourse__T__T__ };
/** @constructor */
function $c_Lmealorama_MealCourse() {
  this.k0 = null;
  this.g6 = null;
}
export { $c_Lmealorama_MealCourse as $c_Lmealorama_MealCourse };
$p = $c_Lmealorama_MealCourse.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_MealCourse;
/** @constructor */
function $h_Lmealorama_MealCourse() {
}
export { $h_Lmealorama_MealCourse as $h_Lmealorama_MealCourse };
$h_Lmealorama_MealCourse.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.hE = (function() {
  return this.k0;
});
$p.m = (function() {
  return this.hE();
});
//# sourceMappingURL=mealorama.-Meal-Course.js.map
